
import { useStore } from "../../state/state.ts";
import Measure from "../measure.tsx";
import ModalLueftung from "../../modals/modal_lueftung.tsx";
import ModalLueftungFuture from "../../modals/modal_lueftung_future.tsx";
import { MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT_LABELS, MASSNAHMEN_LUEFTUNG_OPTIONS_NEW_LABELS } from "../../state/types.ts";

export default function MeasureWidgetLueftung() {
  // @ts-ignore:TS6133
  //const _properties = useStore((state)=>state.properties); //MUST EXIST FOR REACTIVITY TO WORK
  const lueftung = useStore((state)=>state.lueftung || "");
  const lueftung_future = useStore((state)=>state.lueftung_future || "");

  const push_modal = useStore((state) => state.push_modal_closeable);
  const is_step_id = useStore((state) => state.is_step_id);
  const measure_lables = useStore((state)=>state.measure_lables);

  if (lueftung == "" && lueftung_future == ""){
    return <></>;
  }

        const current = measure_lables[lueftung] || MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT_LABELS[lueftung] || "" ;
        const future = measure_lables[lueftung_future] || MASSNAHMEN_LUEFTUNG_OPTIONS_NEW_LABELS[lueftung_future] || "" ;
  return <Measure key={"measure-widget-lueftung"} label={"Lüftung"} now={current} future={future} onClick={() => push_modal(is_step_id("future")?<ModalLueftungFuture/>:<ModalLueftung/>)}/>;
}
